import { render, staticRenderFns } from "./politicsProjectCreate.vue?vue&type=template&id=59cd7bbe&scoped=true"
import script from "./politicsProjectCreate.vue?vue&type=script&lang=js"
export * from "./politicsProjectCreate.vue?vue&type=script&lang=js"
import style0 from "./politicsProjectCreate.vue?vue&type=style&index=0&id=59cd7bbe&prod&lang=less&scoped=true"
import style1 from "./politicsProjectCreate.vue?vue&type=style&index=1&id=59cd7bbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cd7bbe",
  null
  
)

export default component.exports